/* 361 Sleep theme — shop, collection and search pages (snippets/shop-browser.liquid).
   Filters, sort and the price range run over the rendered product cards: data-type, data-pos, data-feat
   (from the product tags), data-price (cents), data-order. State mirrors the URL, so links such as
   /collections/all?type=pillows or ?pos=side&feat=cool land pre-filtered. Search pages use the f_ prefix. */
(() => {
  const S = window.SITE;
  const root = document.querySelector("[data-shop]");
  if (!S || !root) return;
  const $ = (id) => document.getElementById(id);
  const STR = JSON.parse(root.querySelector("[data-shop-str]").textContent);
  const P = root.dataset.prefix || "";
  const grid = $("grid");
  const cards = [...grid.querySelectorAll(".card")];
  const lang = document.documentElement.lang || "ar";

  /* card data */
  const items = cards.map((el, i) => ({
    el, i,
    type: el.dataset.type || "",
    pos: (el.dataset.pos || "").split(/\s+/).filter(Boolean),
    feat: (el.dataset.feat || "").split(/\s+/).filter(Boolean),
    price: Number(el.dataset.price || 0) / 100,
    order: Number(el.dataset.order || 99),
    name: (el.querySelector("h3 bdi")?.textContent || el.dataset.title || "").trim(),
  }));

  /* price range bounds in the visitor's currency: SAR gives 100 to 1300 in steps of 10, as on the approved page */
  const prices = items.map((x) => x.price);
  const top = Math.max(1, ...prices), low = prices.length ? Math.min(...prices) : 0;
  const step = Math.max(1, 10 ** (Math.floor(Math.log10(top)) - 1));
  const LO = Math.floor(low / (step * 10)) * step * 10;
  const HI = Math.max(LO + step * 10, Math.ceil((top * 1.3) / (step * 10)) * step * 10);
  const GAP = step * 5;

  /* state <-> URL; only values that exist as filter options are accepted */
  const valid = (k) => new Set([...root.querySelectorAll(`#groups input[name="${k}"]`)].map((i) => i.value));
  const q = new URLSearchParams(location.search);
  const read = (k) => q.getAll(P + k).flatMap((v) => v.split(",")).map((v) => v.trim().toLowerCase()).filter((v) => valid(k).has(v));
  const SORTS = STR.sorts;
  const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
  const state = {
    type: read("type"), pos: read("pos"), feat: read("feat"),
    min: clamp(Number(q.get(P + "min")) || LO, LO, HI), max: clamp(Number(q.get(P + "max")) || HI, LO, HI),
    sort: SORTS[q.get(P + "sort")] ? q.get(P + "sort") : "featured",
  };
  function syncURL() {
    const u = new URLSearchParams(location.search);
    ["type", "pos", "feat", "min", "max", "sort"].forEach((k) => u.delete(P + k));
    ["type", "pos", "feat"].forEach((k) => state[k].forEach((v) => u.append(P + k, v)));
    if (state.min > LO) u.set(P + "min", state.min);
    if (state.max < HI) u.set(P + "max", state.max);
    if (state.sort !== "featured") u.set(P + "sort", state.sort);
    history.replaceState(null, "", u.toString() ? `?${u}` : location.pathname);
  }

  /* filter groups: tick from state, counts per option */
  const label = (k, v) => root.querySelector(`#groups input[name="${k}"][value="${v}"]`)?.nextElementSibling?.textContent || v;
  root.querySelectorAll("#groups input").forEach((i) => {
    i.checked = state[i.name].includes(i.value);
    const n = items.filter((x) => (i.name === "type" ? x.type === i.value : x[i.name].includes(i.value))).length;
    i.closest(".opt").querySelector(".c").textContent = n;
  });
  $("groups").addEventListener("change", (e) => {
    const i = e.target; if (!i.name) return;
    state[i.name] = [...root.querySelectorAll(`#groups input[name="${i.name}"]:checked`)].map((x) => x.value);
    update();
  });

  /* price range */
  const minI = $("min"), maxI = $("max");
  [minI, maxI].forEach((el) => { el.min = LO; el.max = HI; el.step = step; });
  minI.value = state.min; maxI.value = state.max;
  function paintRange() {
    const a = (state.min - LO) / (HI - LO) * 100, b = (state.max - LO) / (HI - LO) * 100;
    $("fill").style.insetInlineStart = a + "%"; $("fill").style.insetInlineEnd = (100 - b) + "%";
    $("minV").innerHTML = S.money(state.min * 100); $("maxV").innerHTML = S.money(state.max * 100);
  }
  let rt;
  [minI, maxI].forEach((el) => el.addEventListener("input", () => {
    let a = Number(minI.value), b = Number(maxI.value);
    if (a > b - GAP) { if (el === minI) a = b - GAP; else b = a + GAP; minI.value = a; maxI.value = b; }
    state.min = a; state.max = b; paintRange();
    clearTimeout(rt); rt = setTimeout(update, 180);
  }));

  /* sort dropdown */
  const sortEl = $("sort"), trig = sortEl.querySelector(".trigger"), listEl = $("sortList");
  function paintSort() {
    $("sortLabel").textContent = SORTS[state.sort];
    listEl.innerHTML = Object.entries(SORTS).map(([k, t]) => `<li><button type="button" role="option" aria-selected="${k === state.sort}" data-sort="${k}">${S.esc(t)}${k === state.sort ? S.ICON.check.replace("<svg", '<svg style="width:1rem;height:1rem"') : ""}</button></li>`).join("");
  }
  /* open the list toward whichever side has room, so it never hangs off the screen */
  const placeSort = () => { const t = trig.getBoundingClientRect(); const w = listEl.offsetWidth || 230; const roomLeft = t.right - w > 8; listEl.style.right = roomLeft ? "0" : "auto"; listEl.style.left = roomLeft ? "auto" : "0"; };
  addEventListener("resize", placeSort);
  const setOpen = (o) => { placeSort(); sortEl.classList.toggle("open", o); trig.setAttribute("aria-expanded", String(o)); };
  trig.addEventListener("click", () => setOpen(!sortEl.classList.contains("open")));
  listEl.addEventListener("click", (e) => { const b = e.target.closest("[data-sort]"); if (!b) return; state.sort = b.dataset.sort; setOpen(false); paintSort(); update(); });
  document.addEventListener("click", (e) => { if (!sortEl.contains(e.target)) setOpen(false); });
  addEventListener("keydown", (e) => { if (e.key === "Escape") setOpen(false); });

  /* chips + reset */
  const fmt = (n) => S.fmt(n * 100);
  function paintChips() {
    const chips = [];
    ["type", "pos", "feat"].forEach((k) => state[k].forEach((v) => chips.push([k, v, label(k, v)])));
    if (state.min > LO || state.max < HI) chips.push(["price", "", STR.chipPrice.replace("__MIN__", fmt(state.min)).replace("__MAX__", fmt(state.max))]);
    $("chips").innerHTML = chips.map(([k, v, t]) => `<button class="achip" type="button" data-k="${k}" data-v="${v}" aria-label="${S.esc(STR.chipRemove.replace("__T__", t))}">${S.esc(t)}${S.ICON.close}</button>`).join("");
  }
  $("chips").addEventListener("click", (e) => {
    const b = e.target.closest(".achip"); if (!b) return;
    if (b.dataset.k === "price") { state.min = LO; state.max = HI; minI.value = LO; maxI.value = HI; paintRange(); }
    else { state[b.dataset.k] = state[b.dataset.k].filter((x) => x !== b.dataset.v); const i = root.querySelector(`#groups input[name="${b.dataset.k}"][value="${b.dataset.v}"]`); if (i) i.checked = false; }
    update();
  });
  function resetAll() {
    state.type = []; state.pos = []; state.feat = []; state.min = LO; state.max = HI;
    root.querySelectorAll("#groups input").forEach((i) => (i.checked = false));
    minI.value = LO; maxI.value = HI; paintRange(); update();
  }
  $("clearAll").addEventListener("click", resetAll);
  $("emptyReset").addEventListener("click", resetAll);

  /* results: type and position match any ticked option, features must all match */
  function results() {
    const r = items.filter((p) =>
      (!state.type.length || state.type.includes(p.type)) &&
      (!state.pos.length || state.pos.some((v) => p.pos.includes(v))) &&
      (!state.feat.length || state.feat.every((v) => p.feat.includes(v))) &&
      p.price >= state.min && p.price <= state.max);
    const s = {
      featured: (a, b) => a.order - b.order || a.i - b.i,
      "price-asc": (a, b) => a.price - b.price || a.i - b.i,
      "price-desc": (a, b) => b.price - a.price || a.i - b.i,
      name: (a, b) => a.name.localeCompare(b.name, lang),
    }[state.sort];
    return r.sort(s);
  }
  const countText = (n) => n === items.length ? STR.countAll.replace("__N__", n) : n === 1 ? STR.countOne : n === 2 ? STR.countTwo : STR.countMany.replace("__N__", n);
  let first = true;
  function render() {
    const r = results(), shown = new Set(r);
    items.forEach((x) => { x.el.style.display = shown.has(x) ? "" : "none"; });
    r.forEach((x) => grid.append(x.el));
    $("empty").hidden = r.length > 0;
    $("count").textContent = countText(r.length);
    paintChips();
    const active = state.type.length + state.pos.length + state.feat.length + (state.min > LO || state.max < HI ? 1 : 0);
    $("filtersOpenLabel").textContent = `${STR.filters}${active ? ` (${active})` : ""}`;
    if (first) { cards.forEach((c) => c.setAttribute("data-reveal", "")); S.observe(grid); first = false; }
    else cards.forEach((c) => c.classList.add("in"));
  }
  function update() {
    syncURL();
    if (document.startViewTransition && !matchMedia("(prefers-reduced-motion: reduce)").matches) document.startViewTransition(render);
    else render();
  }

  /* mobile sheet */
  const filters = $("filters");
  const openF = (o) => { filters.classList.toggle("open", o); document.body.classList.toggle("lock", o); };
  $("filtersOpen").addEventListener("click", () => openF(true));
  $("filtersApply").addEventListener("click", () => openF(false));
  $("filtersClose").addEventListener("click", () => openF(false));

  paintRange(); paintSort(); render(); placeSort();
})();
